import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { memoize } from '@infl-ts/util-function';
import { i18nLocizeInstance } from '@infl-ts/util-locize-launcher';
import { LOCIZE_API_KEY, LOCIZE_PROJECT_ID, LOCIZE_VERSION } from '../env';
var options = {
  defaultNS: 'InflAdvocate',
  ns: 'InflAdvocate'
};

var createI18nInstance = function createI18nInstance(lang) {
  return i18nLocizeInstance({
    projectId: LOCIZE_PROJECT_ID,
    apiKey: LOCIZE_API_KEY,
    options: _objectSpread(_objectSpread({}, options), {}, {
      lang: lang,
      fallbackLang: lang,
      version: LOCIZE_VERSION
    })
  });
};

export var i18nInstance = memoize(createI18nInstance);